import { InjectionToken } from '@angular/core';

export const MONITOR_DATA_CONFIG = new InjectionToken<MonitorDataConfig>(
  'monitor-data-config',
);

export type MonitorDataConfig = {
  apiPrefix: string;
};
